<mat-card>
  <mat-card-title>{{ getTitleMessageKey() | translate }}</mat-card-title>
  <mat-card-content>
    <div class="content__body">
      <app-banner>
        <ng-container
          *ngIf="
            (installationFeaturesStore.isTheOnlyRoomWithDevices(data.room) | async) &&
              isRoomWithOneDevice();
            then lastDeviceMessage;
            else normalMessage
          "
        ></ng-container>

        <ng-template #normalMessage>{{ getNormalMessageKey() | translate }}</ng-template>

        <ng-template #lastDeviceMessage>{{ getLastDeviceMessageKey() | translate }}</ng-template>
      </app-banner>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      mat-stroked-button
      gtm="onDeleteRoom"
      gtmAction="Delete Room Cancel"
      gtmCategory="deleteRoom"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.NO' | translate }}
    </button>
    <button
      mat-raised-button
      gtm="onDeleteRoom"
      gtmAction="Delete Room Confirm"
      gtmCategory="deleteRoom"
      color="primary"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.YES' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
